export default __webpack_public_path__ + "static/media/dualswitch.65e9abd0.png";